import { useContext } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import Login from '../../pages/login/Login'
import { GlobalContext } from '../../context/Context'
import StockSupplyInventoryLayout from '../../pages/stock-and-supply-management'
import StockSupplyInvOrgLayout from '../../pages/stock-and-supply-management/organization'
import StockSupplyOrgOverview from '../../pages/stock-and-supply-management/organization/overview'
import StockSupplyList from '../../pages/stock-and-supply-management/organization/list'
import ItemAnalysis from '../../pages/stock-and-supply-management/organization/item-analysis'
import StockSupplyTrendList from '../../pages/stock-and-supply-management/organization/trend'
import StockSupplyBuildingList from '../../pages/stock-and-supply-management/organization/building-list'
import StockSupplyVendorList from '../../pages/stock-and-supply-management/organization/vendor'
import StockSupplyCategoryList from '../../pages/stock-and-supply-management/organization/category'
import StockSupplyInvoice from '../../pages/stock-and-supply-management/organization/invoice'
import StockSupplyInvConfigLayout from '../../pages/stock-and-supply-management/config'
import StockSupplyConfigCategories from '../../pages/stock-and-supply-management/config/category'
import StockSupplyConfigItems from '../../pages/stock-and-supply-management/config/items'
import StockSupplyConfigVariants from '../../pages/stock-and-supply-management/config/variants'
import WaterTankerLayout from '../../pages/water-tanker'
import WaterTankerOrgLayout from '../../pages/water-tanker/organization'
import WaterOrgOverview from '../../pages/water-tanker/organization/overview'
import WaterTankerList from '../../pages/water-tanker/organization/list'
import WaterTankerInvoices from '../../pages/water-tanker/organization/invoice'
import TankerBuildingList from '../../pages/water-tanker/organization/building-list'
import WaterTankerTrendList from '../../pages/water-tanker/organization/trend'
import TankerVendorList from '../../pages/water-tanker/organization/vendor'
import FuelInventoryLayout from '../../pages/fuel-inventory'
import FuelInvOrgLayout from '../../pages/fuel-inventory/organization'
import FuelOrgOverview from '../../pages/fuel-inventory/organization/overview'
import FuelList from '../../pages/fuel-inventory/organization/list'
import FuelTrendList from '../../pages/fuel-inventory/organization/trend'
import FuelBuildingList from '../../pages/fuel-inventory/organization/building-list'
import FuelVendorList from '../../pages/fuel-inventory/organization/vendor'
// import MySpaceLayout from '../../pages/report'
// import MySpaceOrgLayout from '../../pages/report/organization'
// import ReportOverview from '../../pages/report/organization/overview'
import FleetLayout from '../../pages/fleet'
import FleetMySpaceLayout from '../../pages/fleet/my-data'
import FleetMySpaceOverview from '../../pages/fleet/my-data/overview'
import FleetMySpaceCarDetail from '../../pages/fleet/my-data/car-detail'
import FleetTeamLayout from '../../pages/fleet/team'
import FleetTeamOverview from '../../pages/fleet/team/overview'
import FleetTeamCar from '../../pages/fleet/team/car'
import FleetTeamVan from '../../pages/fleet/team/van'
import FleetOrganizationLayout from '../../pages/fleet/organization'
import FleetOrganizationOverview from '../../pages/fleet/organization/overview'
import FleetVendorList from '../../pages/fleet/organization/vendor-list'
import FleetCarList from '../../pages/fleet/organization/car-list'
import FleetVanList from '../../pages/fleet/organization/van-list'
import FleetInvoiceList from '../../pages/fleet/organization/invoice-list'
import FleetMileageList from '../../pages/fleet/organization/mileage-list'
import CarDamageList from '../../pages/fleet/organization/car-damage'
import FleetLicenseList from '../../pages/fleet/organization/license-list'
import VanDamageList from '../../pages/fleet/organization/van-damage'
import VanLicenseList from '../../pages/fleet/organization/van-license-list'
import ElectricityConfigLayout from '../../pages/electricity-config'
import ElectricityMeter from '../../pages/electricity-config/meter'
import ElectricityBillLayout from '../../pages/electricity'
import ElectricBillOrgLayout from '../../pages/electricity/organization'
import BillList from '../../pages/electricity/organization/list'
import MonthlySummary from '../../pages/electricity/organization/monthly-summary'
import BillOrgOverview from '../../pages/electricity/organization/overview'
import LocationSummary from '../../pages/electricity/organization/location-summary'
import MonthlyLocationSummary from '../../pages/electricity/organization/monthly-location-summary'
import OfficeAssetsLayout from '../../pages/office-assets'
import OfficeAssetConfigLayout from '../../pages/office-assets/config'
import OfficeAssetsCategory from '../../pages/office-assets/config/category'
import OfficeAssetOrgLayout from '../../pages/office-assets/organization'
import OfficeAssetsList from '../../pages/office-assets/organization/list'
import AssetsVendorList from '../../pages/office-assets/organization/vendor'
import AssetsRepairList from '../../pages/office-assets/organization/repair'
import OfficeAssetSummaryLayout from '../../pages/office-assets/summary'
import OfficeAssetCategoryList from '../../pages/office-assets/summary/category'
import OfficeAssetHealthList from '../../pages/office-assets/summary/health'
import OfficeAssetsConsumablesList from '../../pages/office-assets/organization/consumables'
import OfficeAssetOrgOverview from '../../pages/office-assets/organization/overview'
import FleetCarLayout from '../../pages/fleet/car'
import FleetCarOverview from '../../pages/fleet/car/overview'
import FleetVanLayout from '../../pages/fleet/van'
import FleetVanOverview from '../../pages/fleet/van/overview'
import MeterSummary from '../../pages/electricity/organization/meter-summary'
import VendorConfigLayout from '../../pages/vendors'
import AllVendorList from '../../pages/vendors/vendor'
import LocationMeterSummary from '../../pages/electricity/organization/location-summary-meter'
// import ReportList from '../../pages/report/organization/list'
// import MonthlyLocationSummary from '../../pages/report/organization/monthly-location-summary'
// import LocationSummary from '../../pages/report/organization/location-summary'

const MyRoutes = () => {
  let { state } = useContext(GlobalContext);
  const redirectUrl = sessionStorage.getItem("redirectUrl")
  return (
    <Routes>
      {(state?.isLogin === true) ? (
        <>
          <Route path='/stock-and-supply-management' element={<StockSupplyInventoryLayout />} >
            <Route path='organization' element={<StockSupplyInvOrgLayout />}>
              <Route path='overview' element={<StockSupplyOrgOverview />} />
              <Route path='list' element={<StockSupplyList />} />
              <Route path='item-analysis' element={<ItemAnalysis />} />
              <Route path='trend-list' element={<StockSupplyTrendList />} />
              <Route path='building-list' element={<StockSupplyBuildingList />} />
              <Route path='fuel-vender' element={<StockSupplyVendorList />} />
              <Route path='category' element={<StockSupplyCategoryList />} />
              <Route path='invoice' element={<StockSupplyInvoice />} />
            </Route>

            <Route path='config' element={<StockSupplyInvConfigLayout />}>
              <Route path='categories' element={<StockSupplyConfigCategories />} />
              <Route path='items' element={<StockSupplyConfigItems />} />
              <Route path='variants' element={<StockSupplyConfigVariants />} />
            </Route>

            <Route index element={<Navigate to={'/stock-and-supply-management/organization/overview'} replace />} />
            <Route path='*' element={<Navigate to={'/stock-and-supply-management/organization/overview'} replace />} />
          </Route>

          <Route path='/water-tanker' element={<WaterTankerLayout />} >
            <Route path='organization' element={<WaterTankerOrgLayout />}>
              <Route path='overview' element={<WaterOrgOverview />} />
              <Route path='list' element={<WaterTankerList />} />
              <Route path='invoices' element={<WaterTankerInvoices />} />
              <Route path='by-location' element={<TankerBuildingList />} />
              <Route path='trend-list' element={<WaterTankerTrendList />} />
              <Route path='tanker-vender' element={<TankerVendorList />} />
              {/* <Route path='building-list' element={<FuelBuildingList />} /> */}
            </Route>

            <Route index element={<Navigate to={'/water-tanker/organization/overview'} replace />} />
            <Route path='*' element={<Navigate to={'/water-tanker/organization/overview'} replace />} />
          </Route>

          <Route path='/fuel-inv' element={<FuelInventoryLayout />} >
            <Route path='organization' element={<FuelInvOrgLayout />}>
              <Route path='overview' element={<FuelOrgOverview />} />
              <Route path='list' element={<FuelList />} />
              <Route path='trend-list' element={<FuelTrendList />} />
              <Route path='building-list' element={<FuelBuildingList />} />
              <Route path='fuel-vender' element={<FuelVendorList />} />
            </Route>

            <Route index element={<Navigate to={'/fuel-inv/organization/overview'} replace />} />
            <Route path='*' element={<Navigate to={'/fuel-inv/organization/overview'} replace />} />
          </Route>

          {/* <Route path='/report' element={<MySpaceLayout />} >
            <Route path='organization' element={<MySpaceOrgLayout />}>
              <Route path='overview' element={<ReportOverview />} />
              <Route path='location-summary' element={<LocationSummary />} />
              <Route path='list' element={<ReportList />} />
              <Route path='monthly-location-summary' element={<MonthlyLocationSummary />} />
            </Route>

            <Route index element={<Navigate to={'/report/organization/overview'} replace />} />
            <Route path='*' element={<Navigate to={'/report/organization/overview'} replace />} />
          </Route> */}

          <Route path='/fleet' element={<FleetLayout />} >
            <Route path='my-space' element={<FleetMySpaceLayout />}>
              <Route path='overview' element={<FleetMySpaceOverview />} />
              <Route path='car-details' element={<FleetMySpaceCarDetail />} />

              <Route index element={<Navigate to={'/fleet/my-space/overview'} replace />} />
              <Route path='*' element={<Navigate to={'/fleet/my-space/overview'} replace />} />
            </Route>

            <Route path='car' element={<FleetCarLayout />}>
              <Route path='overview' element={<FleetCarOverview />} />
              <Route path='vendor-list' element={<FleetVendorList />} />
              <Route path='car-list' element={<FleetCarList />} />
              <Route path='invoice-list' element={<FleetInvoiceList />} />
              <Route path='mileage-list' element={<FleetMileageList />} />
              <Route path='car-damage-list' element={<CarDamageList />} />
              <Route path='license-list' element={<FleetLicenseList />} />

              <Route index element={<Navigate to={'/fleet/car/overview'} replace />} />
              <Route path='*' element={<Navigate to={'/fleet/car/overview'} replace />} />
            </Route>

            <Route path='van' element={<FleetVanLayout />}>
              <Route path='overview' element={<FleetVanOverview />} />
              <Route path='van-list' element={<FleetVanList />} />
              <Route path='van-damage-list' element={<VanDamageList />} />
              <Route path='van-license-list' element={<VanLicenseList />} />

              <Route index element={<Navigate to={'/fleet/van/overview'} replace />} />
              <Route path='*' element={<Navigate to={'/fleet/van/overview'} replace />} />
            </Route>

            {/* <Route path='team' element={<FleetTeamLayout />}>
              <Route path='overview' element={<FleetTeamOverview />} />
              <Route path='car' element={<FleetTeamCar />} />
              <Route path='van' element={<FleetTeamVan />} />

              <Route index element={<Navigate to={'/fleet/my-space/overview'} replace />} />
              <Route path='*' element={<Navigate to={'/fleet/my-space/overview'} replace />} />
            </Route>

            <Route path='organization' element={<FleetOrganizationLayout />}>
              <Route path='overview' element={<FleetOrganizationOverview />} />
              <Route path='vendor-list' element={<FleetVendorList />} />
              <Route path='car-list' element={<FleetCarList />} />
              <Route path='van-list' element={<FleetVanList />} />
              <Route path='invoice-list' element={<FleetInvoiceList />} />
              <Route path='mileage-list' element={<FleetMileageList />} />
              <Route path='car-damage-list' element={<CarDamageList />} />
              <Route path='license-list' element={<FleetLicenseList />} />
              <Route path='van-damage-list' element={<VanDamageList />} />
              <Route path='van-license-list' element={<VanLicenseList />} />

              <Route index element={<Navigate to={'/fleet/organization/overview'} replace />} />
              <Route path='*' element={<Navigate to={'/fleet/organization/overview'} replace />} />
            </Route> */}

            <Route index element={<Navigate to={'/fleet/my-space/overview'} replace />} />
            <Route path='*' element={<Navigate to={'/fleet/my-space/overview'} replace />} />
          </Route>

          <Route path='/electricity-config' element={<ElectricityConfigLayout />} >
            <Route path='meter' element={<ElectricityMeter />} />

            <Route index element={<Navigate to={'/electricity-config/meter'} replace />} />
            <Route path='*' element={<Navigate to={'/electricity-config/meter'} replace />} />
          </Route>

          <Route path='/vendors' element={<VendorConfigLayout />} >
            <Route path='all-vendors' element={<AllVendorList />} />

            <Route index element={<Navigate to={'/vendors/all-vendors'} replace />} />
            <Route path='*' element={<Navigate to={'/vendors/all-vendors'} replace />} />
          </Route>

          <Route path='/electric-bill' element={<ElectricityBillLayout />} >
            <Route path='organization' element={<ElectricBillOrgLayout />}>
              {/* <Route path='overview' element={<FuelOrgOverview />} /> */}
              <Route path='list' element={<BillList />} />
              <Route path='overview' element={<BillOrgOverview />} />
              <Route path='location-summary' element={<LocationSummary />} />
              <Route path='meter-new-summary' element={<LocationMeterSummary />} />
              <Route path='monthly-summary' element={<MonthlySummary />} />
              <Route path='meter-summary' element={<MeterSummary />} />
              <Route path='monthly-location-summary' element={<MonthlyLocationSummary />} />
              {/* <Route path='trend-list' element={<FuelTrendList />} />
              <Route path='building-list' element={<FuelBuildingList />} />
              <Route path='fuel-vender' element={<FuelVendorList />} /> */}
            </Route>

            <Route index element={<Navigate to={'/electric-bill/organization/list'} replace />} />
            <Route path='*' element={<Navigate to={'/electric-bill/organization/list'} replace />} />
          </Route>

          <Route path='/office-assets' element={<OfficeAssetsLayout />} >
            <Route path='organization' element={<OfficeAssetOrgLayout />}>
              <Route path='overview' element={<OfficeAssetOrgOverview />} />
              <Route path='list' element={<OfficeAssetsList />} />
              <Route path='vendors' element={<AssetsVendorList />} />
              <Route path='repair-log' element={<AssetsRepairList />} />
              <Route path='consumables' element={<OfficeAssetsConsumablesList />} />
              {/* <Route path='item-analysis' element={<ItemAnalysis />} />
              <Route path='building-list' element={<StockSupplyBuildingList />} />
              <Route path='fuel-vender' element={<StockSupplyVendorList />} />
              <Route path='category' element={<StockSupplyCategoryList />} />
              <Route path='invoice' element={<StockSupplyInvoice />} /> */}
            </Route>

            <Route path='summary' element={<OfficeAssetSummaryLayout />}>
              <Route path='categories' element={<OfficeAssetCategoryList />} />
              <Route path='health' element={<OfficeAssetHealthList />} />
            </Route>

            <Route path='config' element={<OfficeAssetConfigLayout />}>
              <Route path='categories' element={<OfficeAssetsCategory />} />
            </Route>

            <Route index element={<Navigate to={'/office-assets/organization/overview'} replace />} />
            <Route path='*' element={<Navigate to={'/office-assets/organization/overview'} replace />} />
          </Route>

          <Route path='*' element={<Navigate to={'/stock-and-supply-management/organization/overview'} />} />
        </>
      )
        :
        (state?.isLogin === false) ?
          <>
            <Route path='/login' element={<Login />} />
            <Route path='*' element={<Navigate to={'/login'} />} />
          </>
          :
          <></>
      }

    </Routes>
  )
}

export default MyRoutes